<template>
  <md-toolbar
    id="toolbar"
    md-elevation="0"
    class="md-transparent md-absolute bg-color"
    :class="extraNavClasses"
    :color-on-scroll="colorOnScroll"
    :style="headerImage"
  >
    <div class="md-toolbar-row md-collapse-lateral">
      <div class="md-toolbar-section-start">
        <a href="/wap">
          <img
            height="50px"
            width="auto"
            :src="bg.logo"
            alt=""
            style="width: 100%; max-height: 45px"
          />
        </a>
      </div>
      <div class="lang-mobile">
        <el-dropdown trigger="click" @command="handleCommand">
          <span class="el-dropdown-link">
            <flag :iso="locale || 'vn'" v-bind:squared="false" />
            <span class="text-lang">{{ locale || "vn" }}</span>
            <i class="el-icon-arrow-down el-icon--right white-color"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item
              v-for="lang in languages"
              :key="lang.title"
              :value="lang.language"
              :command="lang.language"
            >
              <flag :iso="lang.flag" v-bind:squared="false" />
              <span class="text-lang-item">{{
                lang.flag
              }}</span></el-dropdown-item
            >
          </el-dropdown-menu>
        </el-dropdown>
      </div>
      <div class="md-toolbar-section-end">
        <md-button
          class="md-just-icon md-simple md-toolbar-toggle"
          :class="{ toggled: toggledClass }"
          @click="toggleNavbarMobile()"
        >
          <span
            :style="{ color: `${bg.c_menu_header} !important` }"
            class="icon-bar "
          ></span>
          <span
            :style="{ color: `${bg.c_menu_header} !important` }"
            class="icon-bar"
          ></span>
          <span
            :style="{ color: `${bg.c_menu_header} !important` }"
            class="icon-bar"
          ></span>
        </md-button>

        <div class="md-collapse">
          <div class="md-collapse-wrapper">
            <mobile-menu nav-mobile-section-start="false">
              <!-- Here you can add your items from the section-start of your toolbar -->
            </mobile-menu>
            <md-list>
              <md-list-item @click="toggleNavbarMobile" href="/wap/hot-deal">
                <p>{{ $t("titleHotDeal") }}</p>
              </md-list-item>

              <md-list-item @click="toggleNavbarMobile" href="/wap/top-course">
                <p>{{ $t("titleTop10") }}</p>
              </md-list-item>
              <md-list-item
                @click="toggleNavbarMobile"
                href="/wap/good-yard-area/1"
              >
                <p>{{ $t("titleMenuArea") }}</p>
              </md-list-item>
              <!-- <md-list-item @click="toggleNavbarMobile" href="#/blog">
              <p>BLOG</p>
            </md-list-item> -->
              <md-list-item
                @click="toggleNavbarMobile"
                href="/wap/history-booked"
                v-if="!showLogin"
              >
                <p>{{ $t("history") }}</p>
              </md-list-item>
              <md-list-item
                @click="toggleNavbarMobile"
                v-if="!showLogin"
                href="#"
              >
                <p>vID{{ admin.id_display || admin.vga }}</p>
              </md-list-item>
              <md-list-item class="lang-pc">
                <el-dropdown trigger="click" @command="handleCommand">
                  <span class="el-dropdown-link">
                    <flag :iso="locale || 'vn'" v-bind:squared="false" />
                    <span class="text-lang">{{ locale || "vn" }}</span>
                    <i
                      class="el-icon-arrow-down el-icon--right white-color"
                    ></i>
                  </span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item
                      v-for="lang in languages"
                      :key="lang.title"
                      :value="lang.language"
                      :command="lang.language"
                    >
                      <flag :iso="lang.flag" v-bind:squared="false" />
                      <span class="text-lang-item">{{
                        lang.flag
                      }}</span></el-dropdown-item
                    >
                  </el-dropdown-menu>
                </el-dropdown>
              </md-list-item>
              <!-- <md-list-item @click="handleLogin" v-if="showLogin" href="#">
              <p>
                ĐĂNG NHẬP
              </p>
            </md-list-item>http://localhost:8080/wap/hot-deal
            <md-list-item @click="handleLogout" v-if="!showLogin" href="#">
              <p>
                ĐĂNG XUẤT
              </p>
            </md-list-item> -->
            </md-list>
          </div>
        </div>
      </div>
    </div>
  </md-toolbar>
</template>

<script>
import MobileMenu from "@/layout/MobileMenu";
import { getToken, setupLoginWap } from "@/utils/auth.js";
import i18n from "@/plugins/i18n";
import {
  getBackGround,
  getInfo,
  setFlag,
  setLanguage
} from "../../utils/wapAuth";

export default {
  components: {
    MobileMenu
  },
  props: {
    type: {
      type: String,
      default: "white",
      validator(value) {
        return [
          "white",
          "default",
          "primary",
          "danger",
          "success",
          "warning",
          "info"
        ].includes(value);
      }
    },
    colorOnScroll: {
      type: Number,
      default: 0
    },
    logo: {
      default: require("@/assets/img/logo/W_Booking_white.png")
    }
  },
  data() {
    return {
      bg: getBackGround(),
      extraNavClasses: "",
      toggledClass: false,
      admin: getToken(),
      headerImage: {
        background: getBackGround().headerImage
          ? `url(${getBackGround().headerImage})`
          : getBackGround().c_banner + "!important",
        paddingTop: " 10px",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "auto",
        backgroundAttachment: "fixed",
        backgroundSize: "100% 100%"
      },
      languages: [
        { flag: "vn", language: "vi", title: "Tiếng Việt" },
        { flag: "us", language: "en", title: "English" },
        { flag: "kr", language: "kr", title: "한국어" },
        { flag: "jp", language: "jp", title: "日本語" }
      ],
      locale: localStorage.getItem("flag")
    };
  },
  created() {
    setupLoginWap(this);
    this.extraNavClasses = `md-white`;
  },
  computed: {
    showDownload() {
      const excludedRoutes = ["login", "landing", "profile"];
      return excludedRoutes.every(r => r !== this.$route.name);
    },
    showLogin() {
      return !getInfo();
      // return !window.localStorage.getItem("token");
    }
  },
  methods: {
    bodyClick() {
      let bodyClick = document.getElementById("bodyClick");

      if (bodyClick === null) {
        let body = document.querySelector("body");
        let elem = document.createElement("div");
        elem.setAttribute("id", "bodyClick");
        body.appendChild(elem);

        let bodyClick = document.getElementById("bodyClick");
        bodyClick.addEventListener("click", this.toggleNavbarMobile);
      } else {
        bodyClick.remove();
      }
    },

    toggleNavbarMobile() {
      this.NavbarStore.showNavbar = !this.NavbarStore.showNavbar;
      this.toggledClass = !this.toggledClass;
      this.bodyClick();
    },

    handleCommand(command) {
      // console.log("Command received:", command);

      i18n.locale = command;
      setLanguage(command);

      switch (command) {
        case "en":
          this.locale = "us";
          setFlag("us");
          // console.log("Locale set to:", this.locale);
          // console.log("Flag set to: us");
          break;
        case "vi":
          this.locale = "vn";
          setFlag("vn");
          // console.log("Locale set to:", this.locale);
          // console.log("Flag set to: vn");
          break;
        case "kr":
          this.locale = "kr";
          setFlag("kr");
          // console.log("Locale set to:", this.locale);
          // console.log("Flag set to: kr");
          break;
        case "jp":
          this.locale = "jp";
          setFlag("jp");
          // console.log("Locale set to:", this.locale);
          // console.log("Flag set to: jp");
          break;
        default:
          this.locale = command;
          setFlag(command);
          // console.log("Locale set to:", this.locale);
          // console.log("Flag set to:", command);
          break;
      }
    }
  },
  mounted() {
    // document.addEventListener("scroll", this.scrollListener);
  },
  beforeDestroy() {
    // document.removeEventListener("scroll", this.scrollListener);
  }
};
</script>

<style scoped>
.lang-mobile {
  background: v-bind("bg.c_header") !important ;
  display: none;
}
.md-list-item .md-list-item-content p {
  color: v-bind("bg.c_menu_header");
  font-weight: 500;
}

.text-lang {
  color: v-bind("bg.c_menu_header");
  padding-left: 4px;
  font-weight: 500;
  text-transform: uppercase;
}
.text-lang-item {
  padding-left: 4px;
  text-transform: uppercase;
}
.white-color {
  color: v-bind("bg.c_menu_header");
}
@media (max-width: 991px) {
  .md-collapse-lateral .md-collapse::before {
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    position: absolute;
    display: block;
    background-color: v-bind("bg.c_header") !important;
    content: "";
    z-index: 1;
  }
}
@media screen and (min-width: 0px) and (max-width: 980px) {
  .md-collapse::before {
    position: fixed;
    display: block;
    top: 0;
    height: 100vh;
    width: 230px !important;
    right: 0;
    left: auto;
    z-index: 1032;
    visibility: visible;
    background-color: v-bind("bg.c_header") !important;
    overflow-y: visible;
    border-top: none;
    text-align: left;
    padding-right: 0px;
    padding-left: 0;
  }
  .lang-mobile {
    background: #0000 !important ;
    display: block;
    padding-left: 25px;
  }
  .lang-pc {
    display: none;
  }
}
</style>
